import { render } from "./OwnershipFilter.vue?vue&type=template&id=ddfd0dca"
import script from "./OwnershipFilter.vue?vue&type=script&lang=js"
export * from "./OwnershipFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__